import { Injectable } from "@angular/core";
import { LaunchDialogService } from "@spartacus/storefront";

@Injectable({providedIn: 'root'})
export class CartImportDialogService extends LaunchDialogService {}